<div class="container-fluid nav-bgr fixed-top">
  <div class="container" [ngStyle]="{ 'width.px': 1140 }">
    <nav class="navbar navbar-expand-md navbar-light custom-navbar-settings">
      <a class="navbar-brand" href="#" id="top">
        <app-logo></app-logo>
      </a>

      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="fa fa-bars"></span>
      </button>

      <div class="collapse navbar-collapse mt-5" id="navbarNav">
        <ul class="navbar-nav me-auto" role="navigation" id="lendNav">
          <li class="nav-item">
            <a class="nav-link" href="#overview">Overview</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#trading">Trading</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#what">What?</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#more">More</a>
          </li>
        </ul>

        <div class="btn-group" role="group" aria-label="login or register">
          <button
            class="btn btn-primary"
            [ngStyle]="{ 'min-width.px': 100 }"
            type="button"
            (click)="openAuthentication('Login')"
          >
            Sign in
          </button>
        </div>
      </div>
    </nav>
  </div>
</div>
<video
  #vid
  id="lendingVideo"
  playsinline
  autoplay
  muted
  loop
  poster="assets/images/cover.jpg"
>
  <source src="assets/images/lending-market.mp4" type="video/mp4" />
  <source src="assets/images/lending-market.webm" type="video/webm" />
</video>

<div
  id="start"
  class="container-fluid cover-container d-flex align-items-center w-100 h-100 mx-auto"
>
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-7 mt-5 mt-lg-0">
        <p class="text-start pr-lg-5">
          XCDE SWAP/Lend is an electronic marketplace to Rollover Cryptocurrency
          positions vs. Fiat, with a simple “borrow/lend” trade native to the
          Foreign Exchange markets: FX Swaps<br /><br />XCDE trades are cleared
          by FXCH Ltd.
        </p>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-5"></div>
      <div class="col-12">
        <a
          href="#overview"
          class="btn btn-lg btn-secondary mx-auto intro-button"
          >Overview <i class="fa fa-angle-double-down" aria-hidden="true"></i
        ></a>
      </div>
    </div>
  </div>
</div>

<div class="empty-block"></div>

<div class="container">
  <div class="row">
    <div class="col-md-6">
      <div class="card flip-card testimonial-card item">
        <div class="inner">
          <div class="flip-card-front">
            <div class="card-body">
              <img
                src="assets/images/trade-window.png"
                alt="trade window"
                class="img-fluid"
              />
            </div>
          </div>

          <div
            class="flip-card-back d-flex align-items-center justify-content-center"
          >
            <h3 class="card-title">Borrow 100 BTC overnight.</h3>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="card flip-card testimonial-card item">
        <div class="inner">
          <div class="flip-card-front">
            <div class="card-body">
              <img
                src="assets/images/trade-window.png"
                alt="trade window"
                class="img-fluid"
              />
            </div>
          </div>

          <div
            class="flip-card-back d-flex align-items-center justify-content-center"
          >
            <h3 class="card-title">Borrow 100 BTC overnight.</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid bg-success section">
  <h1>Overview</h1>

  <figure class="figure">
    <img
      src="assets/images/trade-history.png"
      alt="trade history"
      class="figure-img img-center"
    />
    <figcaption class="figure-caption mt-5">
      Buy 100 BTC today, sell 100 BTC tomorrow
    </figcaption>
  </figure>
</div>

<footer class="footer">
  <div class="container">
    <!-- TODO: explicit styling should be moved to css -->
    <a href="https://fxclr.com/" target="_blank"
      ><img
        src="assets/images/FXCH.v2.1.png"
        alt="trade history"
        class="img-center"
        style="width: 13vw"
    /></a>
    <p>© FXCH Ltd.</p>
  </div>
</footer>
